export default {
  good (state) {
    return state.good.topics
  },
  job (state) {
    return state.job.topics
  },
  ask (state) {
    return state.ask.topics
  },
  share (state) {
    return state.share.topics
  },
  dev (state) {
    return state.dev.topics
  }
}



// WEBPACK FOOTER //
// ./src/store/category/getters.js